module.exports = __webpack_public_path__ + "img/skl-logo.47b4d779.png";